import useTranslation from 'next-translate/useTranslation';

import styles from './feature-auth.module.less';

/* eslint-disable-next-line */
export interface FeatureAuthProps {}

export function FeatureAuth(props: FeatureAuthProps) {
  const { t } = useTranslation('common');

  return (
    <div className={styles['container']}>
      <h1>{t('welcome_to_feature_auth')}</h1>
    </div>
  );
}

export default FeatureAuth;
